import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { CheckIcon } from 'lucide-react';
const Pricing = () => {
  const [annual, setAnnual] = useState(false);
  return <section id="pricing" className="py-16 bg-cream" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold font-display text-charcoal" data-id="element-168">
            Simple, Transparent Pricing
          </h2>
          <p className="mt-4 text-lg text-sage max-w-2xl mx-auto" data-id="element-169">
            No hidden fees, no long-term contracts. Start with a 14-day free
            trial.
          </p>
          <div className="mt-8 flex justify-center" data-id="element-170">
            <div className="bg-white p-1 rounded-full flex items-center" data-id="element-171">
              <button className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${!annual ? 'bg-burgundy text-white' : 'text-charcoal'}`} onClick={() => setAnnual(false)} data-id="element-172">
                Monthly
              </button>
              <button className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${annual ? 'bg-burgundy text-white' : 'text-charcoal'}`} onClick={() => setAnnual(true)} data-id="element-173">
                Annual <span className="text-xs ml-1" data-id="element-174">Save 2 months</span>
              </button>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-175">
          {/* Starter Plan */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-176">
            <div className="p-6 border-b border-gray-100" data-id="element-177">
              <h3 className="text-xl font-semibold text-charcoal" data-id="element-178">Starter</h3>
              <div className="mt-4" data-id="element-179">
                <span className="text-4xl font-bold text-charcoal" data-id="element-180">$49</span>
                <span className="text-sage" data-id="element-181">/month</span>
              </div>
              {annual && <p className="text-sm text-sage mt-1" data-id="element-182">
                  $490/year • 2 months free
                </p>}
            </div>
            <div className="p-6" data-id="element-183">
              <ul className="space-y-4" data-id="element-184">
                <li className="flex items-start" data-id="element-185">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-186" />
                  <span className="text-sm" data-id="element-187">1 restaurant location</span>
                </li>
                <li className="flex items-start" data-id="element-188">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-189" />
                  <span className="text-sm" data-id="element-190">
                    Up to 2,000 messages per month
                  </span>
                </li>
                <li className="flex items-start" data-id="element-191">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-192" />
                  <span className="text-sm" data-id="element-193">
                    3 connected channels (Facebook, Instagram & WhatsApp)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-194">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-195" />
                  <span className="text-sm" data-id="element-196">Basic analytics</span>
                </li>
                <li className="flex items-start" data-id="element-197">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-198" />
                  <span className="text-sm" data-id="element-199">Email support</span>
                </li>
              </ul>
              <div className="mt-8" data-id="element-200">
                <Link to="/signup" className="inline-flex w-full justify-center items-center px-4 py-2 border-2 border-burgundy text-burgundy hover:bg-burgundy hover:text-cream transition-colors text-base font-medium rounded-md" data-id="element-201">
                  Start Free Trial
                </Link>
              </div>
            </div>
          </div>
          {/* Professional Plan */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-burgundy" data-id="element-202">
            <div className="p-6 border-b border-gray-100" data-id="element-203">
              <h3 className="text-xl font-semibold text-charcoal" data-id="element-204">
                Professional
              </h3>
              <div className="mt-4" data-id="element-205">
                <span className="text-4xl font-bold text-charcoal" data-id="element-206">$129</span>
                <span className="text-sage" data-id="element-207">/month</span>
              </div>
              {annual && <p className="text-sm text-sage mt-1" data-id="element-208">
                  $1,290/year • 2 months free
                </p>}
            </div>
            <div className="p-6" data-id="element-209">
              <ul className="space-y-4" data-id="element-210">
                <li className="flex items-start" data-id="element-211">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-212" />
                  <span className="text-sm" data-id="element-213">1 restaurant location</span>
                </li>
                <li className="flex items-start" data-id="element-214">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-215" />
                  <span className="text-sm" data-id="element-216">
                    Up to 10,000 messages per month
                  </span>
                </li>
                <li className="flex items-start" data-id="element-217">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-218" />
                  <span className="text-sm" data-id="element-219">
                    5 connected channels (Facebook, Instagram, WhatsApp, Email,
                    Website Chat)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-220">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-221" />
                  <span className="text-sm" data-id="element-222">Google Reviews management</span>
                </li>
                <li className="flex items-start" data-id="element-223">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-224" />
                  <span className="text-sm" data-id="element-225">Reservation management</span>
                </li>
                <li className="flex items-start" data-id="element-226">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-227" />
                  <span className="text-sm" data-id="element-228">Full analytics dashboard</span>
                </li>
                <li className="flex items-start" data-id="element-229">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-230" />
                  <span className="text-sm" data-id="element-231">Priority email & chat support</span>
                </li>
              </ul>
              <div className="mt-8" data-id="element-232">
                <Link to="/signup" className="inline-flex w-full justify-center items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-burgundy hover:bg-burgundy/90 transition-colors" data-id="element-233">
                  Start Free Trial
                </Link>
              </div>
            </div>
          </div>
          {/* Enterprise Plan */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-234">
            <div className="p-6 border-b border-gray-100" data-id="element-235">
              <h3 className="text-xl font-semibold text-charcoal" data-id="element-236">
                Enterprise
              </h3>
              <div className="mt-4" data-id="element-237">
                <p className="text-2xl font-bold text-charcoal" data-id="element-238">
                  Contact Sales
                </p>
                <p className="text-sm text-sage mt-2" data-id="element-239">
                  Custom pricing for your restaurant group
                </p>
              </div>
              <p className="text-sm text-sage mt-2" data-id="element-240">Minimum 5 restaurants</p>
            </div>
            <div className="p-6" data-id="element-241">
              <ul className="space-y-4" data-id="element-242">
                <li className="flex items-start" data-id="element-243">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-244" />
                  <span className="text-sm" data-id="element-245">
                    Multi-restaurant support (minimum 5 locations)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-246">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-247" />
                  <span className="text-sm" data-id="element-248">
                    Unlimited messages across all locations
                  </span>
                </li>
                <li className="flex items-start" data-id="element-249">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-250" />
                  <span className="text-sm" data-id="element-251">
                    5 connected channels per restaurant (Facebook, Instagram,
                    WhatsApp, Email, Website Chat)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-252">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-253" />
                  <span className="text-sm" data-id="element-254">
                    Google Reviews management per restaurant
                  </span>
                </li>
                <li className="flex items-start" data-id="element-255">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-256" />
                  <span className="text-sm" data-id="element-257">
                    Reservation management per restaurant
                  </span>
                </li>
                <li className="flex items-start" data-id="element-258">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-259" />
                  <span className="text-sm" data-id="element-260">
                    Centralized analytics dashboard
                  </span>
                </li>
                <li className="flex items-start" data-id="element-261">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-262" />
                  <span className="text-sm" data-id="element-263">Dedicated account manager</span>
                </li>
                <li className="flex items-start" data-id="element-264">
                  <CheckIcon size={20} className="text-success flex-shrink-0 mt-0.5 mr-2" data-id="element-265" />
                  <span className="text-sm" data-id="element-266">Priority support with SLA</span>
                </li>
              </ul>
              <div className="mt-8" data-id="element-267">
                <Link to="/signup" className="inline-flex w-full justify-center items-center px-4 py-2 border-2 border-burgundy text-burgundy hover:bg-burgundy hover:text-cream transition-colors text-base font-medium rounded-md" data-id="element-268">
                  Contact Sales
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Pricing;